<div class="full-width">
    <div class="card-inline">
        <h3>Estudios anteriores</h3>
    </div>


    <mat-divider></mat-divider>
    <div class="center full-width">
        <mat-spinner *ngIf="loading"></mat-spinner>
        <h4 *ngIf="idsImage64.length == 0 && !loading">No existen estudios digitalizados</h4>
        <div *ngIf="idsImage64.length > 0 && !loading" class="center preview-image-scann">
            <div class="display-button">
                <button (click)="goBack()" mat-icon-button>
          <mat-icon>arrow_back</mat-icon>
        </button> {{getDisplayIndex()}}
                <button (click)="next()" mat-icon-button>
          <mat-icon>arrow_forward</mat-icon>
        </button>
            </div>
            <img mat-card-image class="preview-image" *ngIf="!deleting && !loadingImage" (click)="zoom()" [src]="getSafeUrl()">
            <mat-spinner *ngIf="deleting || loadingImage" matSuffix></mat-spinner>
            <mat-card-actions>
                <button *ngIf="!deleting" type="button" (click)="remove()" mat-button>
                      <mat-icon>delete_forever</mat-icon>
                  </button>
                <!-- <button *ngIf="!loadingImage" type="button" (click)="rotate()" mat-button>
                      <mat-icon>rotate_right</mat-icon>
                  </button> -->
            </mat-card-actions>
        </div>

    </div>
</div>

<div class="clearfix">
    <div class="pull-right mt-5">
        <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Salir</button>
    </div>
</div>